import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ProctoringCandidatesComponent } from '../proctoring-candidates/proctoring-candidates.component';
import { catchError, of, Subscription, tap } from 'rxjs';
import { GetProctoringPolicyBindingsPagedPayload } from '@edtech-ui/core/models/proctoring-dashboard-models/get-proctoring-assessment';
import { ToastrService } from 'ngx-toastr';
import { ProctoringService } from '@edtech-ui/core/services/proctoring-dashboard/proctoring.service';
import { AuthServiceService } from '@edtech-ui/core/services/authService/auth-service.service';
import { PermissionForStudents } from '@edtech-ui/access-role-permissions/users-permissions-constants/student-roles-permissions.enum';
import { HasPermissionDirective } from '@edtech-ui/access-role-permissions/users-permissions-directives/has-permissions.directives';


@Component({
	selector: 'app-proctoring-dashboard',
	standalone: true,
	imports: [CommonModule, MatProgressSpinnerModule,
		FormsModule, RouterModule, ProctoringCandidatesComponent,
		HasPermissionDirective
	],
	templateUrl: './proctoring-dashboard.component.html',
	styleUrl: './proctoring-dashboard.component.scss'
})
export class ProctoringDashboardComponent implements OnInit {

	totalCandidates = 0;
	assessmentCount = 0;
	subscription = new Subscription();
	searchText: string = '';
	showColumnDropdown = false;
	currentPage = 1;
	totalPages = 0
	fromDate: string = '';
	toDate: string = '';
	showIntegrityPopup = false;
	minIntegrity: number | null = null;
	maxIntegrity: number | null = null;
	allRuleSets: string = 'All Rulesets';
	selectedStatus: string = 'All Statuses';
	isLoading = false;
	assessmentData: any[] = [];
	total = 0;
	pageSize = 1;
	sortField = '';
	sortOrder: 'asc' | 'desc' = 'asc';
	companyId = '';
	PermissionForStudents = PermissionForStudents;
	hasAssessmentPermission = false;

	constructor(
		private toastr: ToastrService,
		private proctoringService: ProctoringService,
		private authService: AuthServiceService
	) { }


	ngOnInit(): void {
		this.companyId = localStorage.getItem('companyId') || '';
		this.hasAssessmentPermission = this.authService.hasPermission(PermissionForStudents.PROCTORING_ASSESSMENT);
		if (this.hasAssessmentPermission) {
		this.getProctoringAssessment();
		}
	}


	updateCount(count: number) {
		this.totalCandidates = count;
	}


	getProctoringAssessment() {

		if (!this.hasAssessmentPermission) {
			return;
		}

		const payload: GetProctoringPolicyBindingsPagedPayload = {
			page: this.currentPage,
			pageSize: this.pageSize,
			search: this.searchText,
			filters: {
				companyId: this.companyId,
				proctoringEvaluationOn: 'ASSESSMENT',
				proctoringEvaluationOnId: '',
				or: []
			},
			sort: [
				{
					field: 'createdAt',
					order: 'DESC'
				}
			],
			all: false
		};

		this.subscription.add(
			this.proctoringService.getProctoringAssessment(payload).pipe(
				tap((response) => {
					if (response.success) {
						this.assessmentData = response.data.data;
						this.assessmentCount = response.data.pagination.total;
					} else {
						this.toastr.error(response.message);
					}
				}),
				catchError(() => {
					return of(null);
				})
			).subscribe()
		);
	}


}